"use client";
import {
  image_default
} from "./chunk-NK4BRF7C.mjs";
import {
  useImage
} from "./chunk-AJLGONGP.mjs";
export {
  image_default as Image,
  useImage
};
